import * as fb from './filebase';
import * as sharepoint from './filebaseSharepoint';
import { FormatDateDataType } from "../../util/genericDateAndTimeFuncs";
import { StateTypeContext } from '../clientportal/types';
import { ActivityCenterContextType } from "../../Context/ActivityCenter";
import { runInnerFunction } from '../../compatManager';
import { folderSpecialChars } from './FileDrive';

export interface lddDriveObj {
    type: number,
    sharepointConfig?: sharepoint.SPFileSystemConfig,
    google?: {}
}

export function hasSpecialCharacter(value: string, charArray: string[]): boolean {
    let ret: boolean = false;
    for (let i = 0; i < charArray.length; i++) {
        if (value.indexOf(charArray[i]) !== -1) {
            ret = true;
            break;
        }
    }
    return ret;
}

function replaceMatterNumberSpecialChar(fileNum: string): string {
    const RegExpSpeciaChar = [".", "?", "/", "\\", "+", "*", "$", "^", "|", "!", "(", ")", "[", "]", "{", "}", ":"];
    folderSpecialChars.forEach(c => {
        let str = "";
        for (let i = 0; i < c.length; i++) {
            if (RegExpSpeciaChar.indexOf(c[i]) !== -1) {
                str += "\\";
            }
            str += c[i];
        }
        const r = new RegExp(str, "g");
        fileNum = fileNum.replace(r, "-");
    })
    fileNum = fileNum.trim();
    return fileNum
}

export module FileDrive_Funcs {
    let myDrive: fb.FileSystem;
    let currentFolder: fb.FolderEntry;
    let mainFolder: fb.FolderEntry;
    let matterNumber: string;
    let setLoadingState;
    let setFolderContent;
    let activityCenter: ActivityCenterContextType;

    export function createLddDrive(config: lddDriveObj, fileNum: string, setIsLoading: Function, setFolderContentInitial: Function, setActivityCenter: ActivityCenterContextType): fb.FileSystem {
        if (config.type === 1) {
            myDrive = createSharepointFileSystem(config.sharepointConfig)
        }
        currentFolder = myDrive.root;
        mainFolder = undefined;

        matterNumber = replaceMatterNumberSpecialChar(fileNum);
        setLoadingState = setIsLoading;
        setFolderContent = setFolderContentInitial;
        activityCenter = setActivityCenter;
        return myDrive;
    }

    export function returnCurrentFolder(): fb.FolderEntry {
        return currentFolder;
    }

    export function isMainFolder(): boolean {
        var ret = false;
        if (mainFolder.fullPath === currentFolder.fullPath) {
            ret = true;
        }
        return ret;
    }

    export function drawPath(): string {
        var ret = "";
        if (currentFolder) {
            ret = currentFolder.buildSubPath();
            ret = ret.substring(`\\${myDrive.config.rootDrive}`.length)
            ret = ret.replace(/\//g, "ldd_tomek_ldd");
            ret = ret.replace(/ldd_tomek_ldd/g, " / ");
        }
        return ret;

    }

    export async function refreshFolder(): Promise<void> {

        try {
            setLoadingState(true);
            if (mainFolder === undefined) {
                await getMainFolder();
            } else {
                getMyFolderContent();
            }
        } catch (e) {
            //lddActivityCenterAdd(e, null, "error", null)
        }
        setLoadingState(false);

    }

    export async function getMainFolder(): Promise<void> {
        try {
            setLoadingState(true);
            if (mainFolder === undefined) {
                await getFolder(matterNumber);
                mainFolder = currentFolder;
            }
            currentFolder = mainFolder;
            await getMyFolderContent();
        } catch (e) {
            //lddActivityCenterAdd(e, null, "error", null)
        }
        setLoadingState(false);
    }

    function createSharepointFileSystem(config: sharepoint.SPFileSystemConfig): fb.FileSystem {
        return new sharepoint.FileSystem(config);
    }

    export async function getParentFolder(): Promise<void> {
        try {
            setLoadingState(true);
            if (!isMainFolder()) {
                currentFolder = await currentFolder.getParent();
            }
            await getMyFolderContent();
        } catch (e) {
            //lddActivityCenterAdd(e, null, "error", null)
        }
        setLoadingState(false);
    }

    export async function getFolder(path: string): Promise<void> {
        try {
            setLoadingState(true);
            currentFolder = await currentFolder.getFolder(path, { create: true });
            await getMyFolderContent();

        } catch (e) {
            console.log(e)
            //lddActivityCenterAdd(e, null, "error", null)
        }
        setLoadingState(false);
    }

    export async function getMyFolderContent(): Promise<Array<fb.FileEntry | fb.FolderEntry>> {
        let List = [];
        if (currentFolder && currentFolder !== myDrive.root) {
            List = await currentFolder.getContentList();
        }
        setFolderContent(List);

        return List
    }

    export async function shareClientConnect(file: fb.FileEntry, portalService, state: StateTypeContext): Promise<void> {
        if (!(state.portalId > "")) {
            activityCenter.Add(`Please initiate Client Connect portal first.`, null, "error", null);
            return;
        }
        const msgID = "shareClientConnect";

        try {
            var docName = file.name;
            activityCenter.Add(`Sharing document '${docName}'.`, null, "loading", msgID);
            var blob = await file.getContent("blob", "pdf") as Blob;
            if (blob.type === 'application/pdf' && blob.size > 50) {
                docName = `${docName.substring(0, docName.indexOf("."))}.pdf`;
                var buff = await blob.arrayBuffer();
                await portalService.uploadDocument(buff, state.portalId, state.appId, docName, 'CPL');
                activityCenter.Add(`'${docName}' shared to Client Connect.`, null, "success", null);
            } else {
                throw `Can't get Blob`;
            }
        } catch (e) {
            activityCenter.Add(`Error sharing '${docName}' ${e}.`, null, "error", null);
        }
        activityCenter.Delete(msgID);
    }


    export async function shareRemoteSigning(file: fb.FileEntry, portalService, state: StateTypeContext): Promise<void> {
        if (!(state.portalId > "")) {
            activityCenter.Add(`Please initiate Client Connect portal first.`, null, "error", null);
            return;
        }
        const msgID = "shareRemoteSigning";
        try {
            var docName = file.name;
            activityCenter.Add(`Sharing document '${docName}'.`, null, "loading", msgID);
            var blob = await file.getContent("blob", "pdf") as Blob;
            if (blob.type === 'application/pdf' && blob.size > 50) {
                docName = `${docName.substring(0, docName.indexOf("."))}.pdf`;
                var buff = await blob.arrayBuffer();
                await portalService.uploadDocument(buff, state.portalId, state.appId, docName, 'DefaultRSPFiles');
                activityCenter.Add(`'${docName}' shared to Remote Signing.`, null, "success", null);
            } else {
                throw `Can't get Blob`;
            }
        } catch (e) {
            activityCenter.Add(`Error sharing '${docName}' ${e}.`, null, "error", null);
        }
        activityCenter.Delete(msgID);
    }

    export async function downloadDocument(file: fb.FileEntry): Promise<void> {
        var msgID = "downloadDocument" + new Date().toISOString();
        try {
            var docName = file.name;
            activityCenter.Add(`Downloading document '${docName}'.`, null, "loading", msgID);
            //var url  = await file.downloadFile();
            var meta: any = await file.getExtendedFields("@microsoft.graph.downloadUrl");
            var url: string = await file.getGraphUrlByID() + `/content`;
            if (meta.value > "") {
                url = meta.value;
            };

            const link = document.createElement('a');
            link.href = url;
            link.download = docName;
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(link.href), 7000);
        } catch (e) {
            activityCenter.Add(`Error downloading '${docName}' ${e}.`, null, "error", null);
        }
        activityCenter.Delete(msgID);
    }

    export async function downloadDocumentAsPDF(file: fb.FileEntry): Promise<void> {
        let msgID = "downloadDocumentAsPDF" + new Date().toISOString();
        let docName = file.name;
        try {
            activityCenter.Add(`Downloading document '${docName}'.`, null, "loading", msgID);
            const blob = await file.getContent("blob", "pdf") as Blob;
            if (blob.type === 'application/pdf' && blob.size > 50) {
                docName = `${docName.substring(0, docName.indexOf("."))}.pdf`;
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = docName;
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(link.href), 7000);
            } else {
                throw `Can't get Blob`;
            }
        } catch (e) {
            activityCenter.Add(`Error downloading '${docName}' ${e}.`, null, "error", null);
        }
        activityCenter.Delete(msgID);
    }

    export async function openDocument(file: fb.FileEntry): Promise<void> {
        const docName = file.name;
        var msgID = "openDocument" + new Date().toISOString();
        activityCenter.Add(`Opening document '${docName}'.`, null, "loading", msgID);
        const link = await file.getShareableUrl();
        window.open(link, "_blank");
        activityCenter.Delete(msgID);
    }

    export function printModDate(item: fb.FileEntry | fb.FolderEntry): string {
        var ret = item.modifiedDate;
        if (ret > "") {
            let d = ret.substring(0, ret.indexOf("T"));
            d = FormatDateDataType(d, "df0");
            ret = `${d}   ${ret.substring(ret.indexOf("T") + 1, ret.indexOf("Z"))}`;
            ret = ret.toUpperCase();
        }
        return ret;
    }

    export async function deleteDocument(file: fb.FileEntry): Promise<void> {
        const docName = file.name;
        await file.remove();
        activityCenter.Add(`Document '${docName}' deleted successfully`, null, "success", null);
        refreshFolder();
    }

    export async function deleteFolder(folder: fb.FolderEntry): Promise<void> {
        const docName = folder.name;
        let content = await folder.getContentList();
        if (content.length === 0) {
            await folder.remove();
            activityCenter.Add(`Folder '${docName}' deleted successfully`, null, "success", null);
            refreshFolder();
        } else {
            activityCenter.Add(`Folder '${docName}' can not be deleted because it has content inside.`, null, "error", null);
        }
    }

    export async function emailDocument(file: fb.FileEntry, SessionID: string): Promise<void> {
        var msgID = "emailDocument" + new Date().toISOString();
        const docName = file.name;
        try {
            activityCenter.Add(`Retrieving document '${docName}'.`, null, "loading", msgID);
            var blob = await file.getContent("blob", "pdf") as Blob;
            if (blob.type === 'application/pdf' && blob.size > 50) {
                var rt = await fetch(`uploadTempFile.asp?SessionID=${SessionID}`, {
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        "Content-Type": blob.type,
                    },
                    body: blob
                });
                let path = await rt.text();
                const params = [file.justName, "pdf", path];
                runInnerFunction('ReactShell.callEmailDriveDocument', params);
            } else {
                throw `Can't get Blob`;
            }
        } catch (e) {
            activityCenter.Add(`Error retrieving '${docName}' ${e}.`, null, "error", null);
        }
        activityCenter.Delete(msgID);
    }
}
